import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './FormMessage.css'

/**
 * FormMessage
 *
 * @class FormMessage
 * @type {any}
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class FormMessage extends Component {
  /**
   * Default Props
   *
   * @type {{cols: number, id: string, name: string, placeholder: string, required: boolean, rows: number, title: string}}
   */
  static defaultProps = {
    // cols: 30,
    id: 'message',
    name: 'message',
    placeholder: 'Your message',
    required: true,
    rows: 5,
    errorText: 'Error'
    // title: "Message Title"
  }

  /**
   * Props Types
   *
   * @type {{cols: shim, id: shim, name: shim, placeholder: shim, required: shim, rows: shim, title: shim}}
   */
  static propTypes = {
    cols: PropTypes.number,
    id: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    rows: PropTypes.number,
    title: PropTypes.string,
    validateFunction: PropTypes.func.isRequired
  }

  /**
   * State
   *
   * @type {{}}
   */
  state = {
    errorClassName: 'FormFieldText-error-hidden',
    inputClassName: 'FormFieldText-valid'
  }

  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props)

    this.inputChange = this.inputChange.bind(this)
  }

  /**
   * Component will receive props
   *
   * @param {object} nextProps
   */
  componentWillReceiveProps(nextProps) {
    let inputClassName = 'FormFieldText-valid'
    let errorClassName = 'FormFieldText-error-hidden'

    if (nextProps.valid === false) {
      inputClassName = 'FormFieldText-invalid'
      errorClassName = 'FormFieldText-error-visible'
    }

    this.setState({
      inputClassName: inputClassName,
      errorClassName: errorClassName
    })
  }

  /**
   * Input change
   *
   * @param event
   */
  inputChange(event) {
    const { inputChange } = this.props

    let inputText = event.target.value

    this.setState({
      inputText: inputText
    })

    if (inputChange !== undefined) {
      inputChange(event)
    }
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const { cols, id, errorText, name, placeholder, required, rows } = this.props
    const { errorClassName, inputClassName } = this.state

    let errorId = id + '-error'

    return (
      <div>
        <textarea
          cols={cols}
          id={id}
          className={inputClassName}
          name={name}
          placeholder={placeholder}
          rows={rows}
          required={required}
          onChange={this.inputChange}
        />
        <div id={errorId} className={errorClassName}>
          {errorText}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page/form/formMessage/FormMessage.jsx